import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertifyService } from '../services/alertify.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-dialog-recuperar-password',
  templateUrl: './dialog-recuperar-password.component.html',
  styleUrls: ['./dialog-recuperar-password.component.scss'],
})
export class DialogRecuperarPasswordComponent implements OnInit {
  registerForm: UntypedFormGroup;

  constructor(
    private alertify: AlertifyService,
    public usrSvc: UserService,
    public router: Router,
    private dialogRef: MatDialogRef<DialogRecuperarPasswordComponent>
  ) {}

  ngOnInit(): void {
    this.registerForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });
  }

  getErrorMessageEmail() {
    if (this.registerForm.get('email')?.hasError('required')) {
      return 'El email es requerido';
    }
    if (this.registerForm.get('email')?.hasError('email')) {
      return 'No es un email valido';
    }
    return '';
  }

  restorePassword() {
    this.dialogRef.close();    
    this.usrSvc.RestorePwdByEmail(this.registerForm.get('email')?.value).subscribe((res) => {
      this.alertify.success('Verifique su correo electrónico');
      this.router.navigate(['']);
      console.log(res);
    });
  }
}
